(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-como-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('como-signup-popup')) return;

    class ComoSignupPopup extends HTMLElement {
      connectedCallback() {
        clearTimeout(this.initTimer);

        this.initTimer = setTimeout(() => {
          if (this.isConnected) this.initialize();
        }, 0);
      }

      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();

        const { signal } = this.controller;

        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;

          if (event.target.closest('[data-popup-open]')) {
            event.preventDefault();
            this.open();
          }

          if (event.target.closest('[data-popup-close]')) {
            event.preventDefault();
            this.close();
          }
        }, { signal });

        let startedOutside = false;

        const outside = event => {
          const rect = this.dialog.getBoundingClientRect();

          return (
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom
          );
        };

        this.dialog.addEventListener('pointerdown', event => {
          startedOutside = event.target === this.dialog && outside(event);
        }, { signal });

        this.dialog.addEventListener('click', event => {
          if (
            startedOutside &&
            event.target === this.dialog &&
            outside(event)
          ) {
            this.close();
          }

          startedOutside = false;
        }, { signal });

        this.addEventListener('como-popup:open', () => {
          this.open();
        }, { signal });

        this.addEventListener('como-popup:close', () => {
          this.close();
        }, { signal });

        this.closest('.shopify-section')?.addEventListener(
          'shopify:section:select',
          () => this.open(),
          { signal }
        );

        if (this.dataset.autoOpen !== 'false') {
          this.open();
        }
      }

      disconnectedCallback() {
        clearTimeout(this.initTimer);
        this.close();
        this.controller?.abort();
      }

      open() {
        if (!this.dialog?.isConnected || this.dialog.open) return;

        this.dialog.showModal();
      }

      close() {
        if (this.dialog?.open) {
          this.dialog.close();
        }
      }
    }

    customElements.define('como-signup-popup', ComoSignupPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
